import { Center } from '@mantine/core';
import DataViewer from '@/layouts/DataViewer/DataViewer.tsx';
import useRetrieveDataset from '@/hooks/api/datasets/useRetrieveDataset.ts';
import useGetDatasetUrlQuery from '@/hooks/api/datasets/useGetDatasetUrlQuery.ts';
import CustomSpinner from '@/components/Spinner.tsx';
import useRetrieveRun from '@/hooks/api/runs/useRetrieveRun.ts';

type props = {
  datasetId: string;
};

function addRunName(filename: string, runName: string): string {
  const lastDotIndex = filename.lastIndexOf('.');
  if (lastDotIndex <= 0) {
    return `${filename} - ${runName}`;
  }
  const name = filename.slice(0, lastDotIndex);
  const extension = filename.slice(lastDotIndex);
  return `${name} - ${runName}${extension}`;
}

const ResultPageDataViewer = ({ datasetId }: props) => {
  const { data: dataset } = useRetrieveDataset(datasetId);

  const { data: run } = useRetrieveRun();

  const { data: datasetUrlResponse } = useGetDatasetUrlQuery(datasetId, true);

  if (!dataset || !datasetUrlResponse?.url || !run) {
    return (
      <Center h={'100%'} w={'100%'}>
        <CustomSpinner size={'md'} />
      </Center>
    );
  }

  return (
    <DataViewer
      dataset={dataset}
      datasetURL={datasetUrlResponse.url}
      fileName={addRunName(datasetUrlResponse.name, run.name)}
      blob_exists={datasetUrlResponse.blob_exists}
    />
  );
};

export default ResultPageDataViewer;
